import React from 'react';
import Text from './text';


export default (obj) => {
    return <Text type="date" {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/datetime.js